// extracted by mini-css-extract-plugin
export var growableInput = "_77-0";
export var tagContainer = "_77-2";
export var textInput = "_77-1";